<div class="footer {{sezione}}"   *ngIf="subscription">
    
    <div class="ghibli">
        <div class="footer-img">
        <img src="assets/logo_{{sezione}}_footer.png" width="auto" height="30"/>
    </div>
        <div class="indirizzo">
            <p><strong class="upper">Ghibli &amp; Wirbel SpA</strong><br>
                Via Circonvallazione, 5<br>27020 - Dorno (Pavia)<br>
                Tel +39.0382.848811<br>Fax +39.0382.84668<br>
                Email <a href="mailto:info@ghibliwirbel.com">info@ghibliwirbel.com</a><br>
                {{'P.IVA 03976160287'|translate}}</p>
        </div>
        <div class="riello">
            <div class="member">RIELLO INDUSTRIES GROUP</div>
            <div class="copy">Copyright © Ghibli & Wirbel SpA</div>
        </div>
    </div>
    <div class="tws">
        <p class="center">Powered by <a href="http://www.twsweb.it" style="color: #fd821f;">TWS</a><br></p>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tws-footer/tws-footer.component.html